import React, { useState } from "react";
import "../../css/global/progressModal/progressModal.scss";

interface ProgressModalProps {
  navigation: string[];
  steps: any[];
  stepsComplete: boolean[];
  stepsAccess: number;
  validation: any;
  submitAction: any;
  submitButtonText: string;
  submitHasBeenClicked: boolean;
  setIsFirstStep: any;
  isFormValid: boolean;
}
const ProgressModal = ({
  navigation,
  steps,
  stepsComplete,
  stepsAccess,
  validation,
  submitAction,
  submitButtonText,
  submitHasBeenClicked,
  setIsFirstStep,
  isFormValid,
}: ProgressModalProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  function disableSubmitButton() {
    if ((submitHasBeenClicked) || (isLastStep() ? !isFormValid : !validation[currentStep])) {
      return true
    } else {
      return false
    }
  }

  function handleNextStepClick() {
    setCurrentStep(currentStep + 1);

    //logic for showing view-continue-editing-modal after first step
    setIsFirstStep(false);
  }

  function handlePreviousStepClick() {
    setCurrentStep(currentStep - 1);
  }

  function isLastStep() {
    return currentStep === navigation.length - 1;
  }

  return (
    <div className="progress-modal">
      <ul className="progress-bar">
        {navigation.map((navItem: string, idx: number) => {
          return (
            <li className="progress-bar-list-items" key={idx}>
              <button
                className={`progress-bar-button ${!validation[idx] && "clickable"}`}
                onClick={() => (setCurrentStep(idx), setIsFirstStep(false))}
                disabled={!stepsComplete[idx]}
              >
                {navItem}
              </button>
              <>
                {idx != navigation.length - 1 && (
                  <div
                    className={`progress-bar-box 
                    ${stepsAccess === idx && "clickable-design"}
                    ${!stepsComplete[idx] && "disable-design"}`}
                  ></div>
                )}
              </>
            </li>
          );
        })}
      </ul>
      {steps[currentStep]}
      <div>
        {currentStep !== 0 ? (
          <button
            className="progress-previous-step-button"
            onClick={handlePreviousStepClick}
          >
            Previous Step
          </button>
        ) : (
          ""
        )}
        <button
          className="progress-next-step-button"
          onClick={isLastStep() ? submitAction : handleNextStepClick}
          disabled={disableSubmitButton()}
          style={{ opacity: !validation[currentStep] ? 0.5 : 1 }}
          autoFocus={isLastStep()}
        >
          {isLastStep() ? submitButtonText : "Next Step"}
        </button>
      </div>
    </div>
  );
};

export default ProgressModal;
